<template>
  <Link
    :href="`/#/managedSoftware/${softwareType}/${item.id}/details/Status`"
    :text="commandText"
  />
</template>

<script>
import {
  ApplePackageManagers,
  ItemTypeConsts,
  StoreModuleMap,
  VppSoftwareAppStatusConsts,
} from 'client/util/Constants';
import { Link } from '@jumpcloud/ui-components';
import { get } from 'lodash';
import { mapActions } from 'vuex';

const { INSTALL_SUCCESS_STATUS } = VppSoftwareAppStatusConsts;

const softwareAppsStatusCollection = StoreModuleMap[ItemTypeConsts.softwareAppsStatus];

export default {
  name: 'CommandStatus',

  components: {
    Link,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
    softwareTypeField: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      commandText: 'X of Y acknowledged',
    };
  },

  computed: {

    softwareType() {
      let value = '';
      const type = get(this.item, this.softwareTypeField, false);
      if (type) {
        value = type === ApplePackageManagers.appleVpp ? 'apple' : 'custom';
      }
      return value;
    },
  },

  mounted() {
    this.setSoftwareAppsId({ softwareAppsId: this.item.id });
    this.getCommandText();
  },

  methods: {
    ...mapActions(softwareAppsStatusCollection, [
      'fetchAll',
      'setSoftwareAppsId',
    ]),

    async getCommandText() {
      const fetchResults = await this.fetchAll();
      const numberOfCommandSent = fetchResults
        .filter(({ state }) => state === INSTALL_SUCCESS_STATUS).length;
      this.commandText = `${numberOfCommandSent} of ${fetchResults.length} acknowledged`;
    },
  },
};

</script>
